export default __webpack_public_path__ + "static/media/battle-onboarding-contract-02.968d623c.png";